module.exports = __webpack_public_path__ + "img/iws-socket.82a5c35b.jpg";